export const initRequest = (
  itemRef: string,
  widgetType: string,
  featureType?: string
) => {
  return {
    mode: "item_edit",
    reference: itemRef,
    config: {
      dependencies: {
        question_editor_api: {
          init_options: {
            base_question_type: {
              hidden: ["shuffle_options"],
            },
            widget_type: "response",
            ui: {
              layout: {
                global_template: "edit",
              },
              change_button: false,
              distractor_rationale_button: {
                enabled: true,
                options: ["perQuestion", "perResponse"],
              },
            },
            label_bundle: {
              "metadata.distractor_rationale": "Student text explanation",
              "metadata.sample_answer": "Rubric",
            },
            question_type_groups: [
              {
                name: "Custom Question Types",
                reference: "custom_q_types",
              },
            ],
            question_type_templates: {
              custom_clock_question: [
                {
                  name: "Custom Question - Clock",
                  description: "A custom question type - Clock",
                  group_reference: "custom_q_types",
                  defaults: {
                    stimulus:
                      "<span>Your question here. Example: </span><br>Oh no! The hands on the clock have gotten all messed up! Help fix the clock by moving the hands to show what time it is! <br><strong>Drag the hands to show 4:30 on the clock.</strong>",
                    type: "custom",
                    js: {
                      question:
                        "https://assets-qa.progresslearning.com/custom-questions/clock/question.js",
                      scorer:
                        "https://assets-qa.progresslearning.com/custom-questions/clock/scorer.js",
                    },
                    css: "https://assets-qa.progresslearning.com/custom-questions/clock/question.css",
                    minute_tolerance: 7,
                    hour_tolerance: 7,
                    score: 1,
                    valid_response: {
                      hourHandAngle: 45,
                      minHandAngle: 90,
                    },
                    instant_feedback: true,
                  },
                },
              ],
            },
            custom_question_types: [
              {
                custom_type: "custom_clock_question",
                type: "custom",
                name: "Custom clock Question",
                editor_layout:
                  "https://assets-qa.progresslearning.com/custom-questions/clock/clock_question_authoring.html",
                js: {
                  question:
                    "https://assets-qa.progresslearning.com/custom-questions/clock/question.js",
                  scorer:
                    "https://assets-qa.progresslearning.com/custom-questions/clock/scorer.js",
                },
                css: "https://assets-qa.progresslearning.com/custom-questions/clock/question.css",
                version: "v1.0.0",
                editor_schema: {
                  hidden_question: false,
                  properties: {
                    instant_feedback: {
                      name: "Check answer button",
                      description:
                        "Enables the Check Answer button underneath the question, which will provide the student with instant feedback on their response(s).",
                      type: "boolean",
                      required: false,
                      default: false,
                    },
                    minute_tolerance: {
                      type: "number",
                      name: "Minute Hand Tolerance",
                      description:
                        "How many degrees off we will tolerate the minute hand angles in validation.",
                      required: true,
                      default: 7,
                    },
                    hour_tolerance: {
                      type: "number",
                      name: "Hour Hand Tolerance",
                      description:
                        "How many degrees off we will tolerate the hour hand angles in validation.",
                      required: true,
                      default: 7,
                    },
                    valid_response: {
                      name: "Set correct answer(s)",
                      description:
                        "In this section, configure the correct answer(s) for the question.",
                      type: "question",
                      white_list: [
                        "minHandAngle",
                        "hourHandAngle",
                        "value",
                        "minute_tolerance",
                        "hour_tolerance",
                      ],
                    },
                    score: {
                      type: "number",
                      name: "Score",
                      description: "Score for a correct answer.",
                      required: true,
                      default: 1,
                    },
                  },
                },
              },
            ],
          },
          preload: true,
        },
      },
      widget_templates: {
        back: false,
        save: false,
        widget_types: {
          default: widgetType,
          show: true,
        },
      },
      container: {
        height: "auto",
        fixed_footer_height: 0,
      },
      item_edit: {
        tags_on_create: [
          {
            type:
              widgetType == "questions"
                ? "Question"
                : featureType
                ? getFeatureName(featureType)
                : "Passage",
            name:
              widgetType == "questions"
                ? "Question"
                : featureType
                ? getFeatureName(featureType)
                : "Passage",
          },
        ],
        item: {
          image_alt_text_generation: {
            enable: true,
            auto_generate: true,
          },
          back: false,
          save: false,
          tag: {
            edit: true,
            show: true,
          },
        },
      },
    },
    user: {
      id: "demoTest",
      firstname: "",
      lastname: "",
      email: "",
    },
  };
};

const getFeatureName = (featureType: string) => {
  let name = "Passage";
  switch (featureType) {
    case "videoplayer":
      name = "Videoplayer";
      break;
    default:
      name = "Passage";
      break;
  }
  return name;
};
